<template>
  <div id="muen-wrap">
    <div class="top-wrap">
      <div class="logo-box">
        <!-- <span>共青团委</span> -->
        <a href="https://www.mini1.cn/">
          <img class="img-logo-mini" src="../assets/images/logo_mini.png" />
        </a>
        <a href="http://www.ncda.org.cn/">
          <img class="img-logo-gong" src="../assets/images/logo_gong.png" />
        </a>
      </div>
      <i class="btn-close" @click="closeMenu">×</i>
    </div>
    <div class="content-wrap">
      <div class="muen-items">
        <div class="btn-go" v-for="(item, index) in menuArr" :key="index">
          <!-- <router-link :to="item.path"> {{ item.txt }}</router-link> -->
          <div @click="toPage(item.path)">{{ item.txt }}</div>
          <i class="line"></i>
        </div>
        <div class="apply-pop">
          <p @click="toApply('/works/1')">学生个人</p>
          <p @click="toApply('/works/2')">院校组织</p>
        </div>
      </div>
      <div class="login-wrap">
        <template>
          <div v-if="isLogin" class="user-info">
            <div class="name">
              欢迎你，<span>{{
                this.$store.getters.currentUser.nickName
              }}</span>
            </div>
            <div @click="logoutFn" class="btn-logout">【退出】</div>
          </div>
          <div v-else class="btn-login" @click="handleLogin">
            <p>登录迷你账号</p>
          </div>
        </template>
      </div>
      <div class="qr-code" v-for="code in codeArr" :key="code.id">
        <img class="qqcode" :src="code.src" />
        <div class="qq-wrap">
          <p>{{ code.name }}</p>
          <p>{{ code.QQ }}</p>
        </div>
      </div>
      <!-- <div class="qr-code">
        <img class="qqcode" src="" />
        <div class="qq-wrap">
          <p>大赛交流群 ②</p>
          <p>QQ群：673014907</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { ssoLoing } from '../common/ssoUrl';
export default {
  name: 'Menu',
  data() {
    return {
      menuArr: [
        { txt: '大赛首页', path: '/' },
        { txt: '赛制规则', path: '/rules' },
        { txt: '参赛指南', path: '/guide' },
        { txt: '报名投稿', path: '/works' },
        { txt: '参赛作品', path: '/show' },
        { txt: '获奖作品', path: '/previous' }
        // { txt: '我的高校', path: '/map' }
      ],
      codeArr: [
        {
          id: 0,
          src: require('../assets/images/qr_code.png'),
          name: '大赛交流群 ①',
          QQ: 'QQ群：973875622'
        },
        {
          id: 1,
          src: require('../assets/images/qr_code2.png'),
          name: '大赛交流群 ②',
          QQ: 'QQ群：673014907'
        }
      ]
    };
  },
  computed: {
    getPathName() {
      return window.sessionStorage.getItem('pathName');
    },
    isLogin() {
      if (window.sessionStorage.getItem('currentUser') != 'null') {
        this.$store.commit(
          'userStatus',
          JSON.parse(window.sessionStorage.getItem('currentUser'))
        );
      } else {
        this.$store.commit('userStatus', null);
      }
      return this.$store.getters.isLogin;
    }
  },
  methods: {
    handleLogin() {
      ssoLoing();
    },
    toPage(path) {
      if (path != '/works') {
        this.$router.push(path);
      }
    },
    toApply(path) {
      if (!this.isLogin) {
        this.$router.push(path);
      } else {
        this.isSignInfo(path);
      }
    },
    async isSignInfo(path) {
      try {
        // 查询是否有报名，在哪报的
        const res = await this.$http.apiIsSign();
        const { data } = res.data;
        if (!data) {
          this.$router.push(path);
        } else {
          let txt = data.ncda ? '院校组织' : '学生个人';
          if (
            (path == '/works/1' && data.ncda) ||
            (path == '/works/2' && !data.ncda)
          ) {
            this.$toast(`您已选择 "${txt}" 通道报名投稿`);
          } else {
            this.$router.push(path);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    closeMenu() {
      if (this.isLogin) {
        this.$router.push({ path: this.getPathName });
      } else {
        this.$router.go(-1);
      }
    },
    logoutFn() {
      this.$sso.clear();
      this.$store.dispatch('setUser', null);
    }
  }
};
</script>

<style lang="scss" scoped>
#muen-wrap {
  width: 750px;

  .top-wrap {
    width: 750px;
    height: 80px;
    background: #000;
    position: fixed;
    z-index: 999;
    top: 0;

    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    padding: 0 20px;
    .logo-box {
      display: flex;
      align-items: center;
      .img-logo-gong {
        // width: 65px;
        // height: 59px;
        width: 148px;
        height: 42px;
        margin-left: 40px;
      }
      span {
        font-size: 28px;
        font-weight: 800;
        margin: 0 20px;
      }
      .img-logo-mini {
        width: 104px;
        height: 37px;
      }
    }
    .btn-close {
      font-size: 60px;
      color: #fff;
    }
  }
  .content-wrap {
    width: 750px;
    height: 85%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    // 菜单
    .muen-items {
      position: relative;
      width: 80%;
      margin-top: 150px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      // align-items: center;
      // justify-content: center;
      color: rgb(53, 53, 53);

      .btn-go {
        width: 100%;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;

        div {
          height: 100px;
          line-height: 100px;
          font-size: 38px;
          // font-weight: 600;
          color: rgb(53, 53, 53);
          // margin-bottom: 10px;
        }
        .line {
          display: block;
          width: 500px;
          height: 2px;
          background: linear-gradient(
            to right,
            rgba(203, 203, 203, 0.1) 0%,
            rgba(203, 203, 203, 0.8) 50%,
            rgba(203, 203, 203, 0.1) 100%
          );
        }
      }
      .apply-pop {
        position: absolute;
        left: 63%;
        top: 300px;

        color: #80313c;
        width: 205px;
        height: 100px;
        background: url('../assets/images/bg_btn_toapply.png') no-repeat top
          center/205px 100px;
        text-align: center;
        font-size: 30px;
        p {
          padding-left: 20px;
          height: 50px;
          line-height: 50px;
          width: 100%;

          text-align: center;
        }
      }
    }
    // 登录
    .login-wrap {
      width: 100%;
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      .user-info {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 80%;
        justify-content: space-around;
        font-size: 30px;
        .name {
          // width: 70%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 40px;
        }
        span {
          color: #129742;
          font-weight: 600;
        }
        .btn-logout {
          color: #ff874b;
        }
      }
      .btn-login {
        width: 281px;
        height: 99px;
        background: url('../assets/images/btn_login.png') no-repeat top
          center/281px 99px;
        color: #692a34;
        font-size: 34px;
        font-weight: 800;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    // 二维码
    .qr-code {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 150px;
        height: 150px;
      }
      .qq-wrap {
        margin-left: 20px;
        font-size: 30px;
      }
    }
  }
}
</style>
